'use strict';
import {module} from '../app';

module.service('Diagram', ['$http', 'authService', function ($http, authService) {
  return {
    get: function (ssn, sdate) {
      const config = { headers:  authService.getTechpadDiagramHeaders() };
      const url = `${authService.currentMagViewUrl()}/api/worklist/diagram?ssn=${ssn}&sdate=${sdate}`;

      return $http.get(url, config);
    },

    getDiagramImage: function (worklistId) {
      const url = `${authService.currentMagViewUrl()}/api/worklist/${worklistId}/diagramImage`;

      return $http.get(url)
    },

    save: function (worklistId, model) {
      const config = { headers:  authService.getTechpadDiagramHeaders() };
      const url = `${authService.currentMagViewUrl()}/api/worklist/${worklistId}/diagram`;

      return $http.post(url, model, config);
    },

    saveForPatient: function (ssn, sdate, worklistId, base64String, model) {
      let clonedModel = angular.copy(model);
      clonedModel.ssn = ssn;
      clonedModel.sdate = sdate;
      clonedModel.worklistId = worklistId;
      clonedModel.base64String = base64String;
      clonedModel.isDiagramChanged = true;
      clonedModel.isDiagramEmpty = base64String === '';
      if(!clonedModel.problems){
        clonedModel.problems = [];
      }
      const config = { headers:  authService.getTechpadDiagramHeaders() };
      const url = `${authService.currentMagViewUrl()}/api/worklist/diagram`;

      return $http.post(url, clonedModel, config);
    },

    saveForPatientWithModel: function (model) {
      const config = { headers:  authService.getTechpadDiagramHeaders() };
      const url = `${authService.currentMagViewUrl()}/api/worklist/diagram`;

      return $http.post(url, model, config);
    },
  
    generateImage: function (worklistId, diagramGenerationModel) {
      const url = `${authService.currentMagViewUrl()}/api/worklist/${worklistId}/diagram/generate`;

      return $http.post(url, diagramGenerationModel);
    },

    prepareSaveModelWithDiagramImage: async function (saveModel, problemsArray) {
      let model = angular.copy(saveModel);
      const hasProblemsInModel = model.Problems && model.Problems.length > 0;
      const hasProblemsInArray = problemsArray && problemsArray.length > 0;
      const hasProblems = hasProblemsInModel || hasProblemsInArray;
      const isDiagramEmpty = model.IsDiagramEmpty;
      
      if ((model.IsDiagramChanged && !isDiagramEmpty) || model.NeedGeneratedImageFromClient) {
        if ((model.SvgDiagramImage && model.SvgDiagramImage.length) > (model.Base64String && model.Base64String.length)) {
          model.SvgDiagramImage = null;
        } else {
          model.Base64String = null;
        }
      } else {
        if (!hasProblems && isDiagramEmpty) {
          model.SvgDiagramImage = null;
          model.Base64String = null;
        }
      }

      return model;
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/scripts/domains/diagram.js